import { render, staticRenderFns } from "./CompanyDropdownSingleSelect.vue?vue&type=template&id=534fb89f&scoped=true&lang=pug&"
import script from "./CompanyDropdownSingleSelect.vue?vue&type=script&lang=js&"
export * from "./CompanyDropdownSingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDropdownSingleSelect.vue?vue&type=style&index=0&id=534fb89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fb89f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
